import Avatar from './avatar';
import './styles/index.scss';
export default Avatar;
